/**
 * Van welk land het btw-tarief op een orderregel geldt. Dat leggen we per regel vast, net als het
 * tarief zelf, zodat de export later per land en tarief kan (OSS) zonder oude bestellingen te raden.
 *
 * Onder de OSS-drempel (€ 10.000 per jaar aan verkoop op afstand naar EU-consumenten buiten
 * Nederland) geldt altijd het Nederlandse tarief, ook voor een pakket naar België. Daarboven het
 * land van aflevering. Of de drempel gehaald is, bepaalt de server (docs/BOEKHOUDING.md §7).
 */

export const HOME_VAT_COUNTRY = 'NL'

/** ISO-landcode in hoofdletters, of het thuisland als hij ontbreekt of niet klopt. */
const clean = (country: string | undefined) => (country && /^[A-Za-z]{2}$/.test(country) ? country.toUpperCase() : HOME_VAT_COUNTRY)

export function vatCountryFor(destination: string | undefined, ossActive = false): string {
  return ossActive ? clean(destination) : HOME_VAT_COUNTRY
}
